var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.734 14.9152C3.422 14.3446 3.422 13.6552 3.73401 13.0847C5.71667 9.45936 9.57058 7 14 7C18.4294 7 22.2834 9.45944 24.266 13.0848C24.578 13.6554 24.578 14.3448 24.266 14.9153C22.2833 18.5406 18.4294 21 14 21C9.57059 21 5.71663 18.5406 3.734 14.9152Z",
    stroke: "#434C63",
    strokeWidth: 1.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 3.5,
    stroke: "#434C63",
    strokeWidth: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.e54729ebc569b75e7108ddcba4fcbf4f.svg";
export { ForwardRef as ReactComponent };